import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import PositionDetail from './components/PositionDetail.vue';
import { reactive, toRefs, onMounted, ref } from 'vue';
import usePosition from './composables/usePosition.js';
import apis from '@/api';
import { srcSuffix } from "@/utils/srcType";
export default {
  components: {
    PositionDetail
    /*ElTabs, ElTabPane,*/
  },
  setup() {
    const form = ref('form');
    const data = reactive({
      activeTab: '001',
      show: false,
      formData: {},
      operation: 'add',
      srcSuffix: srcSuffix,
      rules: {
        nodeName: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        positionType: {
          required: true,
          message: '请选择点位类型',
          trigger: 'blur'
        },
        srcTyp: {
          required: true,
          message: '请选择素材类型',
          trigger: 'blur'
        },
        picSize: {
          required: true,
          message: '请输入点位规格',
          trigger: 'blur'
        },
        picFileSize: {
          required: true,
          message: '请输入文件大小',
          trigger: 'blur'
        },
        status: {
          required: true,
          message: '请选择状态',
          trigger: 'blur'
        },
        sortNumber: {
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }
      }
    });
    let currentNode = {};
    const {
      positionData,
      positionTopNode,
      posDetail,
      initTree,
      addPosition,
      editPosition,
      deletePosition,
      queryPositionById,
      queryPositionChild
    } = usePosition();
    const options = {
      value: 'id',
      label: 'nodeName',
      disabled: 'disabled',
      emitPath: false,
      lazy: true,
      lazyLoad(node, resolve) {
        apis.queryPositionChild(node.data.id).then(res => {
          if (res.success) {
            res.data.forEach(val => {
              val.leaf = val.positionType === 2 ? 1 : 0;
              val.disabled = val.status === 0 ? true : false;
            });
            resolve(res.data);
          }
        });
      }
    };
    onMounted(() => {
      queryPositionChild(''); //只查询顶级节点
      queryPositionChild(data.activeTab); //查询子节点
    });
    const clickTab = i => {
      data.activeTab = i.id;
      queryPositionChild(i.id);
    };
    const addHandler = parent => {
      data.operation = 'add';
      data.show = true;
      data.formData = {};
      currentNode = parent;
    };
    const editHandler = nodeData => {
      data.formData = {};
      data.operation = 'edit';
      data.show = true;
      data.formData = JSON.parse(JSON.stringify(nodeData));
      currentNode = nodeData;
    };
    const confirmHandler = () => {
      form.value.validate(valid => {
        if (valid) {
          if (data.operation === 'add') {
            let json = {
              ...data.formData,
              parentId: currentNode.id
            };
            addPosition(json).then(() => {
              queryPositionChild(data.activeTab);
              data.show = false;
            });
          } else {
            editPosition(data.formData).then(() => {
              queryPositionChild(data.activeTab);
              data.show = false;
            });
          }
        } else {
          return false;
        }
      });
    };
    const delHandler = (node, nodeData) => {
      ElMessageBox.confirm('确定要删除该运营点位吗？').then(() => {
        deletePosition(nodeData).then(() => {
          ElMessageBox({
            type: 'success',
            message: '删除成功！'
          });
        });
      }).catch(() => {});
    };
    const changeNode = id => {
      queryPositionById(id);
    };
    const changeSrcTyp = p => {
      if (p) {
        data.srcSuffix.forEach((val, ind) => {
          if (val.num == p) {
            data.formData.srcTypSuffix = data.srcSuffix[ind].suffix;
          }
        });
      }
    };
    return {
      ...toRefs(data),
      options,
      positionData,
      posDetail,
      positionTopNode,
      form,
      clickTab,
      changeNode,
      confirmHandler,
      addHandler,
      editHandler,
      delHandler,
      changeSrcTyp
    };
  }
};